import { IsInt } from 'class-validator';

export class OrderPositionDeleteRequest {
    @IsInt()
    public id: number;

    constructor(data?: Partial<OrderPositionDeleteRequest>) {
        this.id = data?.id;
    }
}
